// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import Dialog from '../../../components/Dialog';
import { S } from '../ChallengePageStyle';

interface ChallengeTimeUpDialogProps {
  showDialog: boolean;
  closeDialog: () => void;
}

const ChallengeTimeUpDialog = ({ showDialog, closeDialog }: ChallengeTimeUpDialogProps): JSX.Element => {
  const dialogRef = useRef<HTMLDivElement>(null);

  return (
    <Dialog showDialog={showDialog}>
      <S.EndChallengeContainer ref={dialogRef}>
        <S.EndChallengeIcon />
        <S.EndChallengeTitle><FormattedMessage id="E053" /></S.EndChallengeTitle>
        <S.EndChallengeText>
          <FormattedMessage id="E054" values={{ br: <br /> }} />
        </S.EndChallengeText>
        <S.EndChallengeButton onClick={closeDialog}><FormattedMessage id="E025" /></S.EndChallengeButton>
      </S.EndChallengeContainer>
    </Dialog>
  )
}

export default ChallengeTimeUpDialog;
